/**
 * Function to wait for predicates.
 * @param {function() : Boolean} predicate - A function that returns a bool
 * @param {Number} [timeout] - Optional maximum waiting time in ms after rejected
 */
export const waitFor = (predicate: () => boolean, timeout?: number) => {
  return new Promise((resolve, reject) => {
    const check = () => {
      if (!predicate()) return
      clearInterval(interval)
      resolve(true)
    }
    const interval = setInterval(check, 100)

    check()

    if (!timeout) return
    setTimeout(() => {
      clearInterval(interval)
      reject(new Error('timeout'))
    }, timeout)
  })
}
